import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EmployeeAdditionSchema = withDefaults({
  type: 'employee-addition',
  objectExtensions: ['employee-addition'],
  fields: [
    {
      kind: 'attribute',
      name: 'raw',
    },
    {
      kind: 'attribute',
      name: 'operational',
    },
    {
      kind: 'attribute',
      name: 'overrides',
    },
    {
      kind: 'attribute',
      name: 'processed',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: 'employeeAddition',
      },
    },
  ],
});

export default EmployeeAdditionSchema;
